import types from "./types"

export function filterAgendamentos (agendamentoId) {
    return {
            type: types.FILTER_AGENDAMENTO,
            agendamentoId
    }
}

export function getHorariosDisponiveis (colaboradorId) {
    return {
        type: types.GET_HORARIOS_DISPONIVEIS,
        colaboradorId
    }
}

export function updateAgendamento (agendamento) {
    return {
        type: types.UPDATE_AGENDAMENTO,
        agendamento
    }
}

export function updateHorariosDisponiveis (horariosDisponiveis) {
    return {
        type: types.UPDATE_HORARIOS_DISPONIVEIS,
        horariosDisponiveis
    }
}

export function updateComponent (component) {
    return {
        type: types.UPDATE_COMPONENT,
        component
    }
};

export function unlinkAgendamento () {
    return { type: types.UNLINK_AGENDAMENTO  }
}